export default (from, to = new Date()) => {
  return Math.round((from - to) / (1000 * 60 * 60 * 24))
}
